type LinkLike = {
  label: string
}

type TitleFilterItem = {
  title: string
  taskLink?: LinkLike | null
  projectLink?: LinkLike | null
  ancestorTaskLinks?: LinkLike[]
}

export const getTitleFilterValue = ({ projectLink, taskLink, ancestorTaskLinks, title }: TitleFilterItem): string => {
  const ancestorTitles = ancestorTaskLinks?.map((link) => link.label).join(",") || ""
  const projectTitle = projectLink?.label || ""
  const taskTitle = taskLink?.label || ""
  return `${projectTitle} ${ancestorTitles} ${taskTitle} ${title}`
}
